import { NavLink } from "react-router-dom";
import { useClose } from "./Context";
import { menuItemClasses } from "./helpers";

export interface LinkItemProps {
  active?: boolean;
  label: string;
  linkTo: string;
  onClick?: () => void;
}

export const LinkItem = ({
  linkTo,
  label,
  active = false,
  onClick,
}: LinkItemProps) => {
  const handleClick = useClose(onClick);
  return (
    <NavLink
      key={label}
      to={linkTo}
      onClick={handleClick}
      className={menuItemClasses(active)}
      title={label}
    >
      {label}
    </NavLink>
  );
};
